import { EntitiesStore } from './entities-store.abstract';
import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';


/**
 * Interface of Athlete for indoor elite.
 *
 * @interface Athlete
 */
interface Athlete {
  Id: string;
  FName: string;
  GName: string;
  WNameOrd: boolean;
  NOC: string;
}

/**
 * Team information of elite ranking indoor.
 *
 * @interface Team
 */
interface Team {
  TeamId: string;
  TeamName: string;
  TeamCatId: string;
}

/**
 * Model of detail in indoor elite ranking.
 *
 * @interface Detail
 */
interface Detail {
  ID: string;
  Name: string;
  NameShort: string;
  Place: string;
  Country: string;
  Date: string;
  Position: number;
  Score: number;
  Stage: number;
  inTotal: boolean;
}

/**
 * Elite ranking indoor model.
 *
 * @export
 * @interface IEliteRankingSModel
 */
export interface IEliteRankingSModel {
  Rnk: number;
  RnkOld: number;
  Cat: string;
  Score: number;
  Athlete: Athlete;
  Team: Team;
  Details: Detail[];
}

/**
 * Elite ranking indoor store.
 *
 * @export
 * @class EliteRankingIndoorStore
 * @extends {EntitiesStore<IEliteRankingSModel>}
 */
export class EliteRankingIndoorStore extends EntitiesStore<IEliteRankingSModel> {
  constructor(injector: Injector) {
    super('SERIESPRORANKINGS', injector.get(HttpClient));
  }

  /**
   * {@inheritdoc}
   *
   * @memberof EliteRankingIndoorStore
   */
  getRequest(params: any, request_more: boolean) {
    return super.getRequest(params, request_more).pipe(tap(a => {
      this.data.forEach(value => value.Details = value.Details.reverse());
      this.data = this.data;
      this.dataStream.next(this.data);
    }))
  }
}
